"use client";

import { ScrollArea, Separator } from "@atlas/core";
import { cva } from "class-variance-authority";
import type { ReactNode } from "react";

const bodyFooterLayoutViewportStyles = cva(
  "flex flex-col items-center space-y-4 px-6 pb-4 [-webkit-overflow-scrolling:touch]",
);

interface IBodyFooterLayoutProps {
  children: ReactNode;
  footer?: ReactNode;
}

export function BodyFooterLayout({ children, footer }: IBodyFooterLayoutProps) {
  if (footer == null) {
    return (
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <ScrollArea
          className="min-h-0 flex-1"
          viewportClassName={bodyFooterLayoutViewportStyles()}>
          {children}
        </ScrollArea>
      </div>
    );
  }

  return (
    <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden">
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <ScrollArea
          className="min-h-0 flex-1"
          viewportClassName={bodyFooterLayoutViewportStyles()}>
          {children}
        </ScrollArea>
      </div>
      <div className="flex min-w-0 w-full shrink-0 flex-col">
        <Separator decorative />
        <div className="bg-card px-4 py-2">{footer}</div>
      </div>
    </div>
  );
}
